import { useState } from 'react';

export const useDialogHandlers = (
  resetForm: () => void,
  handleClose: () => void
) => {
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);

  const handleDialogClose = () => {
    resetForm();
    handleClose();
  };

  const handleOpenHistory = () => {
    setShowHistoryDialog(true);
  };

  const handleCloseHistory = () => {
    setShowHistoryDialog(false);
  };

  return {
    showHistoryDialog,
    handleDialogClose,
    handleOpenHistory,
    handleCloseHistory
  };
}; 